define('ItemKeyMapping.Configurable', [
    'Item.KeyMapping',
    'SC.Configuration',
    'underscore',
    'Utils'
], function ItemKeyMappingConfigurable(
    ItemKeyMapping,
    Configuration,
    _
) {
    'use strict';

    var htmlParserFields = ['name', 'pageTitle', 'pageHeader'];

    var htmlParser = function htmlParser(input) {
        var label;

        if (SC.isPageGenerator()) {
            return input;
        }

        label = document.createElement('label');
        label.innerHTML = input;

        return (label.hasChildNodes() ? label.firstChild.nodeValue : label.innerText) || '';
    };

    return {
        mountToApp: function mountToApp() {
            var itemKeys = {};
            var itemKeyMapping = ItemKeyMapping.getKeyMapping(Configuration);

            _(Configuration.keyMapping.itemFields).each(function eachItemField(data) {
                var key = '_' + data.itemKey;

                if (_(itemKeyMapping[key]).isFunction()) {
                    itemKeys[key] = function keyFn(item) {
                        return item.get(data.itemField) || itemKeyMapping[key].apply(item, arguments);
                    };
                } else {
                    itemKeys[key] = _(itemKeyMapping[key]).isArray() ? _(itemKeyMapping[key]).clone() : [itemKeyMapping[key]];
                    itemKeys[key].unshift(data.itemField);
                }
            });

            // Decoding HTML custom fields
            _(htmlParserFields).each(function eachParserField(itemKey) {
                var key = '_' + itemKey;
                var itemFields;

                if (_(itemKeys[key]).isFunction()) {
                    itemKeys[key] = _(itemKeys[key]).wrap(function keyFn(fn) {
                        var value = fn.apply(this, _(arguments).toArray().slice(1));

                        return htmlParser(value);
                    });
                } else if (_(itemKeys[key]).isArray()) {
                    itemFields = _(itemKeys[key]).clone();
                    itemKeys[key] = function keyFn(item) {
                        var value = '';

                        _(itemFields).each(function eachItemField(itemField) {
                            value = value || item.get(itemField);
                        });
                        return htmlParser(value);
                    };
                }
            });

            Configuration.itemKeyMapping = _(Configuration.itemKeyMapping || {}).extend(itemKeys);
        }
    };
});

